var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"dense":"","value":_vm.lang,"items":_vm.languages,"label":_vm.$t('config.language')},on:{"change":_vm.onSelectLang}})}
var staticRenderFns = []

export { render, staticRenderFns }